import { render, staticRenderFns } from "./ProfileActivities.vue?vue&type=template&id=7b968d0d&scoped=true"
import script from "./ProfileActivities.vue?vue&type=script&lang=ts"
export * from "./ProfileActivities.vue?vue&type=script&lang=ts"
import style0 from "./ProfileActivities.vue?vue&type=style&index=0&id=7b968d0d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b968d0d",
  null
  
)

export default component.exports